export default __webpack_public_path__ + "static/char-s-04-chs-4e905b966718cef30b58292cde147bb2.png";